import { render, staticRenderFns } from "./ActivityQuery.vue?vue&type=template&id=97576d24&scoped=true"
import script from "./ActivityQuery.vue?vue&type=script&lang=js"
export * from "./ActivityQuery.vue?vue&type=script&lang=js"
import style0 from "./ActivityQuery.vue?vue&type=style&index=0&id=97576d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97576d24",
  null
  
)

export default component.exports